import { FoodOffIcon } from './FoodOffIcon';

/**
 * author: Google
 * id 3731F58E-CAEA-4B54-87A6-7F4E039F2B31
 * name food-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-off.svg
 * tags
 * - Food / Drink 
 */
export const BurgerOffIcon = FoodOffIcon;
export default BurgerOffIcon